/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Landing_DescriptionInputs */

const en_marketing_landing_description = /** @type {(inputs: Marketing_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A full-stack TypeScript starter kit on Cloudflare: auth, organizations, Stripe billing, a public API, realtime, AI, and background work. Typed end to end and tested.`)
};

const es_marketing_landing_description = /** @type {(inputs: Marketing_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un starter kit TypeScript full-stack sobre Cloudflare: autenticación, organizaciones, facturación con Stripe, una API pública, tiempo real, IA y trabajo en segundo plano. Tipado de extremo a extremo y probado.`)
};

const fr_marketing_landing_description = /** @type {(inputs: Marketing_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un starter kit TypeScript full-stack sur Cloudflare : authentification, organisations, facturation Stripe, API publique, temps réel, IA et traitement en arrière-plan. Typé de bout en bout et testé.`)
};

/**
* | output |
* | --- |
* | "A full-stack TypeScript starter kit on Cloudflare: auth, organizations, Stripe billing, a public API, realtime, AI, and background work. Typed end to end and..." |
*
* @param {Marketing_Landing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_landing_description = /** @type {((inputs?: Marketing_Landing_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Landing_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_landing_description(inputs)
	if (locale === "es") return es_marketing_landing_description(inputs)
	return fr_marketing_landing_description(inputs)
});